/*
* Basic Responsive iFrames.
*
* They always take the width of their parent
* They need a block-like display property.
*
* Simples.
*
* Note: add .dont-resize to your iFrame to bypass resizing
*/

import debounce from 'lodash/debounce';
import { findMany, on } from '../helpers';

const targets = [
    '.prose iframe:not(.dont-resize)',
    '[data-resize]',
    '.iframe_wrapper iframe',
];

const handle = () => {
    findMany(targets).forEach(iframe => {
        if (!iframe.parentElement) {
            return;
        }

        const maxWidth = iframe.parentElement.getBoundingClientRect().width,
            ratio = iframe.height / (isNaN(iframe.width) ? iframe.clientWidth : iframe.width),
            height = maxWidth * ratio;

        iframe.classList.add('w-full');
        iframe.classList.add('block');
        iframe.style.height = height + 'px';
    })
}

handle();

on('load', handle, window);
on('resize', debounce(handle, 300), window);
on('iframes::change', handle)
